import { render, staticRenderFns } from "./EditEmail.vue?vue&type=template&id=b613f4f6&scoped=true&"
import script from "./EditEmail.vue?vue&type=script&lang=js&"
export * from "./EditEmail.vue?vue&type=script&lang=js&"
import style0 from "./EditEmail.vue?vue&type=style&index=0&id=b613f4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b613f4f6",
  null
  
)

export default component.exports